/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import CustomLoader from '../../modules/aiadmin/common/components/CustomLoader/CustomLoader';
import { STUDIO_APP_COLOR } from '../../modules/studio/constants/theme';

const SuspenseWrapper = ({ children, size, color, customColor, thickness, label, centered, zIndex, fallback }) => {
  const suspenseFallback = fallback || (
    <CustomLoader
      size={size}
      color={color}
      customColor={customColor}
      thickness={thickness}
      label={label}
      centered={centered}
      zIndex={zIndex}
    />
  );

  return <Suspense fallback={suspenseFallback}>{children}</Suspense>;
};

SuspenseWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.number,
  color: PropTypes.oneOf(['primary', 'secondary', 'inherit', 'error', 'success', 'info', 'warning', 'default']),
  customColor: PropTypes.string,
  thickness: PropTypes.number,
  label: PropTypes.string,
  centered: PropTypes.bool,
  zIndex: PropTypes.number,
  fallback: PropTypes.node
};

SuspenseWrapper.defaultProps = {
  size: 40,
  color: 'primary',
  customColor: STUDIO_APP_COLOR,
  thickness: 3,
  label: null,
  centered: true,
  zIndex: 1200,
  fallback: null
};

export default SuspenseWrapper;
